import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import {
    CARD_SX,
    HEADING_NAVY,
    SECTION_LABEL_SX,
    TILE_ACCENT,
} from './onboardingIntelligence.styles';

interface StatTileProps {
    label: string;
    value: number | string;
    accent?: string;
    testId: string;
    sublabel: string;
}

const StatTile: React.FC<StatTileProps> = ({ label, value, accent, testId, sublabel }) => (
    <Card sx={{ ...CARD_SX, height: '100%' }} data-testid={testId}>
        <CardContent
            sx={{
                padding: '16px 20px',
                // MuiCardContent default has :last-child padding-bottom 24px;
                // override it cleanly via the selector rather than !important.
                '&:last-child': { paddingBottom: '16px' },
            }}
        >
            <Typography variant='subtitle2' sx={SECTION_LABEL_SX}>
                {label}
            </Typography>
            <Typography
                sx={{
                    color: accent ?? HEADING_NAVY,
                    fontFamily: 'Poppins',
                    fontWeight: 700,
                    fontSize: '28px',
                    lineHeight: '34px',
                    marginTop: '4px',
                }}
                data-testid={`${testId}-value`}
            >
                {value}
            </Typography>
            <Typography
                variant='caption'
                sx={{
                    color: 'rgba(0,0,0,0.6)',
                    fontSize: '12px',
                    display: 'block',
                    marginTop: '2px',
                }}
            >
                {sublabel}
            </Typography>
        </CardContent>
    </Card>
);

interface Props {
    totalSuppliers: number;
    readyToGoLive: number;
    highPriority: number;
}

const OnboardingIntelligenceTiles: React.FC<Props> = ({
    totalSuppliers,
    readyToGoLive,
    highPriority,
}) => (
    <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 4 }}>
            <StatTile
                label='Total Suppliers'
                value={totalSuppliers}
                accent={TILE_ACCENT.total}
                sublabel='in pipeline'
                testId='onboarding-intelligence-tile-total'
            />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
            <StatTile
                label='Ready to Go Live'
                value={readyToGoLive}
                accent={TILE_ACCENT.ready}
                sublabel='all tasks complete'
                testId='onboarding-intelligence-tile-ready'
            />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
            <StatTile
                label='High Priority'
                value={highPriority}
                accent={TILE_ACCENT.highPriority}
                sublabel='based on status'
                testId='onboarding-intelligence-tile-high-priority'
            />
        </Grid>
    </Grid>
);

export default OnboardingIntelligenceTiles;
